import { useState, useEffect, useCallback } from 'react';
import { login as apiLogin } from './grcClient.js';

const TOKEN_KEY = 'grc_auditor_token';
const SESSION_KEY = 'grc_auditor_session';

function isExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return payload.exp ? Date.now() / 1000 > payload.exp : true;
  } catch {
    return true;
  }
}

export function useGrcAuth() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const token = localStorage.getItem(TOKEN_KEY);
      const raw = localStorage.getItem(SESSION_KEY);
      if (token && raw && !isExpired(token)) {
        setSession(JSON.parse(raw));
      } else {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(SESSION_KEY);
      }
    } catch {
      /* ignore */
    }
    setLoading(false);
  }, []);

  const login = useCallback(async ({ email, firmSlug, password }) => {
    const data = await apiLogin({ email, firmSlug, password });
    // auditor-login now returns { status, ... }. Pass through MFA challenges
    // so the login UI can handle them; only store the session on status 'ok'.
    if (data.status !== 'ok') return data;
    const token = data.token;
    const user = data.user;
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(SESSION_KEY, JSON.stringify(user));
    setSession(user);
    return data;
  }, []);

  const completeLogin = useCallback((token, user) => {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(SESSION_KEY, JSON.stringify(user));
    setSession(user);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(SESSION_KEY);
    setSession(null);
  }, []);

  return { session, loading, login, completeLogin, logout };
}
